import { render, staticRenderFns } from "./CustomerEditAppointments.vue?vue&type=template&id=6dc95b88&scoped=true"
import script from "./CustomerEditAppointments.vue?vue&type=script&lang=js"
export * from "./CustomerEditAppointments.vue?vue&type=script&lang=js"
import style0 from "./CustomerEditAppointments.vue?vue&type=style&index=0&id=6dc95b88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc95b88",
  null
  
)

export default component.exports